import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../components/toast/ErrorToast";
import {DELIVERY_SITE_PATH} from "../../routes";

export default class DeliverySitesPanelFeature {

    constructor(application, navigator, businessName) {
        this._application = application;
        this._navigator = navigator;
        this._businessName = businessName;
        this._deliverySites = [];

        makeObservable(this, {
            _deliverySites: observable,
            deliverySites: computed,
        });
    }

    async load() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._deliverySites = response.deliverySites();
            },
            handlesError: () => {
                errorToast("No se pudieron obtener los puntos de entrega");
            }
        });
        return this._application.apiClient().customerDeliverySites(responseHandler, this._businessName);
    }

    get deliverySites() {
        return this._deliverySites;
    }

    columns() {
        return [
            {id: 'name', label: 'Nombre'},
            {id: 'address', label: 'Dirección'},
            {id: 'city', label: 'Ciudad'},
            {id: 'code', label: 'Código'},
        ];
    }

    presentedDeliverySites() {
        return this._deliverySites.map(deliverySite => ({
            id: deliverySite.code,
            name: deliverySite.name,
            address: deliverySite.address,
            city: deliverySite.city,
            postalCode: deliverySite.postalCode,
            latitude: deliverySite.latitude,
            longitude: deliverySite.longitude,
            code: deliverySite.code,
        }));
    }

    navigateToDeliverySite(row) {
        const path = DELIVERY_SITE_PATH
            .replace(':customerId', this._businessName)
            .replace(':deliverySiteCode', row.code);
        this._navigator(path, {state: {deliverySite: row}});
    }
}
